module.exports = __webpack_public_path__ + "static/media/dots-active-8.8ca968e2.svg";